import React from 'react';
import { motion } from 'framer-motion';
import { Search, MapPin, Users, CheckCircle2, AlertCircle } from 'lucide-react';
const venues = [{
  name: 'Higher Ground',
  city: 'Burlington, VT',
  cap: 400,
  genres: ['Folk', 'Indie'],
  fit: 94,
  contact: 'good',
  verified: '2 weeks ago'
}, {
  name: 'The Sinclair',
  city: 'Cambridge, MA',
  cap: 525,
  genres: ['Indie', 'Folk'],
  fit: 91,
  contact: 'good',
  verified: '1 month ago'
}, {
  name: 'ArtsRiot',
  city: 'Burlington, VT',
  cap: 250,
  genres: ['Folk', 'Americana'],
  fit: 89,
  contact: 'fair',
  verified: '3 weeks ago'
}, {
  name: 'The Empty Bottle',
  city: 'Chicago, IL',
  cap: 400,
  genres: ['Indie', 'Alt'],
  fit: 86,
  contact: 'excellent',
  verified: '1 week ago'
}, {
  name: 'Beachland Tavern',
  city: 'Cleveland, OH',
  cap: 300,
  genres: ['Folk', 'Rock'],
  fit: 82,
  contact: 'good',
  verified: '2 months ago'
}, {
  name: 'Club Passim',
  city: 'Cambridge, MA',
  cap: 100,
  genres: ['Folk', 'Acoustic'],
  fit: 78,
  contact: 'excellent',
  verified: '1 week ago'
}];
export function VenuesPage() {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} className="max-w-7xl mx-auto" data-id="element-5308">
      {/* Filters */}
      <div className="flex flex-wrap items-center gap-3 mb-6" data-id="element-5309">
        <div className="relative flex-1 min-w-[250px]" data-id="element-5310">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-textMuted" data-id="element-5311" />
          <input type="text" placeholder="Search venues by name, city, or keyword..." className="w-full pl-9 pr-4 py-2 bg-surface border border-border rounded-lg text-sm focus:outline-none focus:border-primary" data-id="element-5312" />
        </div>
        <select className="px-3 py-2 bg-surface border border-border rounded-lg text-sm focus:outline-none focus:border-primary text-textMuted" data-id="element-5313">
          <option data-id="element-5314">Any Capacity</option>
          <option data-id="element-5315">Under 200</option>
          <option data-id="element-5316">200 - 500</option>
          <option data-id="element-5317">500+</option>
        </select>
        <select className="px-3 py-2 bg-surface border border-border rounded-lg text-sm focus:outline-none focus:border-primary text-textMuted" data-id="element-5318">
          <option data-id="element-5319">Any Genre</option>
          <option data-id="element-5320">Folk / Americana</option>
          <option data-id="element-5321">Indie / Alt</option>
        </select>
        <select className="px-3 py-2 bg-surface border border-border rounded-lg text-sm focus:outline-none focus:border-primary text-textMuted" data-id="element-5322">
          <option data-id="element-5323">Any Confidence</option>
          <option data-id="element-5324">High Confidence</option>
        </select>
      </div>

      {/* Venue List */}
      <div className="space-y-4" data-id="element-5325">
        {venues.map((venue, i) => <div key={i} className="bg-surface border border-border rounded-xl p-5 hover:border-primary/50 transition-colors cursor-pointer flex flex-col md:flex-row md:items-center gap-6" data-id="element-5326">
            {/* Main Info */}
            <div className="flex-1" data-id="element-5327">
              <div className="flex items-center gap-3 mb-2" data-id="element-5328">
                <h3 className="text-lg font-semibold" data-id="element-5329">{venue.name}</h3>
                <span className="px-2 py-0.5 bg-primary/10 text-primary text-xs rounded font-medium" data-id="element-5330">
                  {venue.fit}% Fit
                </span>
              </div>
              <div className="flex flex-wrap items-center gap-4 text-sm text-textMuted" data-id="element-5331">
                <div className="flex items-center gap-1.5" data-id="element-5332">
                  <MapPin className="w-4 h-4" data-id="element-5333" />
                  {venue.city}
                </div>
                <div className="flex items-center gap-1.5" data-id="element-5334">
                  <Users className="w-4 h-4" data-id="element-5335" />
                  {venue.cap} cap
                </div>
                <div className="flex items-center gap-2" data-id="element-5336">
                  {venue.genres.map(g => <span key={g} className="px-2 py-0.5 bg-background border border-border rounded text-xs" data-id="element-5337">
                      {g}
                    </span>)}
                </div>
              </div>
            </div>

            {/* Meta Info */}
            <div className="flex flex-row md:flex-col items-center md:items-end justify-between gap-2 md:w-48 shrink-0 border-t md:border-t-0 md:border-l border-border pt-4 md:pt-0 md:pl-6" data-id="element-5338">
              <div className="flex items-center gap-2 text-sm" data-id="element-5339">
                <div className="flex gap-0.5" data-id="element-5340">
                  <div className={`w-1.5 h-1.5 rounded-full ${venue.contact === 'excellent' || venue.contact === 'good' || venue.contact === 'fair' ? 'bg-green-500' : 'bg-border'}`} data-id="element-5341"></div>
                  <div className={`w-1.5 h-1.5 rounded-full ${venue.contact === 'excellent' || venue.contact === 'good' ? 'bg-green-500' : 'bg-border'}`} data-id="element-5342"></div>
                  <div className={`w-1.5 h-1.5 rounded-full ${venue.contact === 'excellent' ? 'bg-green-500' : 'bg-border'}`} data-id="element-5343"></div>
                </div>
                <span className="text-textMuted capitalize" data-id="element-5344">
                  {venue.contact} contact
                </span>
              </div>
              <div className="flex items-center gap-1.5 text-xs text-textMuted" data-id="element-5345">
                {venue.verified.includes('week') ? <CheckCircle2 className="w-3 h-3 text-green-500" data-id="element-5346" /> : <AlertCircle className="w-3 h-3 text-amber-500" data-id="element-5347" />}
                Verified {venue.verified}
              </div>
            </div>
          </div>)}
      </div>
    </motion.div>;
}